import {useMemo, useRef} from 'react';
import isEqual from 'lodash/isEqual';
import type {LockValue} from './types';
import {useCurrentLock} from './useCurrentLock';

export const useCurrentLockValue = (workId: string): LockValue | undefined => {
  const currentLock = useCurrentLock(workId, false);
  const currentLockValueRef = useRef<LockValue | undefined>(undefined);

  return useMemo(() => {
    // Only update ref when loaded
    if (currentLock.status !== 'Loaded') {
      return currentLockValueRef.current;
    }

    const lockValue: LockValue = {
      isLocked: !!currentLock.data,
      lock: currentLock.data,
    };

    if (!isEqual(lockValue, currentLockValueRef.current)) {
      currentLockValueRef.current = lockValue;
    }

    return currentLockValueRef.current;
  }, [currentLock]);
};
